// import React, { useState } from "react";
// import styles from "./StationSetup.module.css";
// import {
//   Dropdown,
//   InputField,
//   SubmitButton,
//   TextComponent,
// } from "../../../../../components";
// import { Button, Card, Col, InputNumber, message, Row, Select } from "antd";
// import { MinusCircleOutlined } from "@ant-design/icons";
// import { useDispatch } from "react-redux";
// import { showAlert } from "../../../../../Store/Actions/GeneralActions";
// import { AiFillCloseCircle } from "react-icons/ai";
// const StationSetup = () => {
//   const dispatch = useDispatch();
//   const [labourPerBatch, setLabourPerBatch] = useState("");

//   const { Option } = Select;
//   const [recommendedSkill, serRecommendedSkill] = useState({
//     value: "Apprentice",
//     id: 1,
//   });
//   const [stations, setStations] = useState([
//     { station: "", skill: "", staff: 3, process: "" },
//   ]);
//   const addStation = () => {
//     const lastStation = stations[stations.length - 1];

//     if (!lastStation.station || !lastStation.skill || !lastStation.process) {
//       dispatch(
//         showAlert({
//           type: "error",
//           message:
//             "Please fill all fields in the current station before adding a new one.",
//         })
//       );
//       return;
//     }
//     setStations([
//       ...stations,
//       { station: "", skill: "", staff: 3, process: "" },
//     ]);
//   };

//   const removeStation = (index) => {
//     // console.log("lastStation", lastStation);
//     // if(lastStation){
//     //      dispatch(
//     //     showAlert({
//     //       type: "error",
//     //       message:
//     //         "Could",
//     //     })
//     //   );
//     //   return;
//     // }
//     setStations(stations.filter((_, i) => i !== index));
//   };

//   const updateStation = (index, key, value) => {
//     const updated = [...stations];
//     updated[index][key] = value;
//     setStations(updated);
//   };

//   return (
//     <div>
//       <div className={styles.TwoInputRow}>
//         <InputField
//           inputStyle={{ backgroundColor: "var(--white-color)" }}
//           className={styles.inputNew}
//           label={"Estimated Labor Time per Batch"}
//           placeholder={"15 minutes"}
//           value={labourPerBatch}
//           onChange={(e) => setLabourPerBatch(e.target.value)}
//         />

//         <Dropdown
//           className={styles.inputNew}
//           label={"Recommended Skill"}
//           value={recommendedSkill}
//           labelStyle={{ fontSize: 18 }}
//           inputStyle={{ backgroundColor: "var(--white-color)" }}
//           style={{ color: "black" }}
//           options={[
//             {
//               value: "Apprentice",
//               id: 1,
//             },
//           ]}
//           onChange={(e) => serRecommendedSkill(e)}
//         />
//       </div>
//       <TextComponent
//         text={"Product Journey"}
//         className={styles.productHeading}
//       />
//       {stations.map((station, index) => (
//         <div key={index} className={styles.stationCard}>
//           <div className={styles.twoStationInput}>
//           <div className={styles.stationContainers}>
//             <Dropdown
//               className={styles.stationsInput}
//               label={"Station"}
//               value={station.station}
//               inputStyle={{ backgroundColor: "var(--white-color)" }}
//               labelStyle={{ fontSize: 18 }}
//               style={{ color: "black" }}
//               options={[
//                 {
//                   value: "Mixing",
//                   id: 1,
//                 },
//                 {
//                   value: "Filling",
//                   id: 2,
//                 },
//               ]}
//               onChange={(e) => updateStation(index, "station", e)}
//             />
//           </div>
//           <div className={styles.stationContainers}>
//             <Dropdown
//               className={styles.stationsInput}
//               label={"Recommended Skill"}
//               value={station.skill}
//               inputStyle={{ backgroundColor: "var(--white-color)" }}
//               labelStyle={{ fontSize: 18 }}
//               style={{ color: "black" }}
//               options={[
//                 {
//                   value: "Apprentice",
//                   id: 1,
//                 },
//                 {
//                   value: "Expert",
//                   id: 2,
//                 },
//               ]}
//               onChange={(e) => updateStation(index, "skill", e)}
//             />
//           </div>
//           </div>
//           <div className={styles.twoStationInput2} >
//           <div className={styles.stationContainers2}>
//             <TextComponent
//               text={"Recommended Number of Staff"}
//               className={styles.stationCounterText}
//             />
//             <div className={styles.stationCounterCont}>
//               <Button
//                 onClick={() =>
//                   updateStation(index, "staff", Math.max(0, station.staff - 1))
//                 }
//               >
//                 -
//               </Button>
//               <InputNumber
//                 min={0}
//                 value={station.staff}
//                 onChange={(e) => updateStation(index, "staff", e)}
//               />
//               <Button
//                 onClick={() => updateStation(index, "staff", station.staff + 1)}
//               >
//                 +
//               </Button>
//             </div>
//           </div>
//           <div className={styles.stationContainers2}>
//             <Dropdown
//               className={styles.stationsInput}
//               label={"Select a Process"}
//               value={station.process}
//               inputStyle={{ backgroundColor: "var(--white-color)" }}
//               labelStyle={{ fontSize: 18 }}
//               style={{ color: "black" }}
//               options={[
//                 {
//                   value: "MIX-SD-BASE",
//                   id: 1,
//                 },
//                 {
//                   value: "FILL-BOTTLE",
//                   id: 2,
//                 },
//               ]}
//               onChange={(e) => updateStation(index, "process", e)}
//             />
//           </div>
//           </div>
//           {stations?.length != 1 && (
//             <div
//               className={styles.closeIcon}
//               onClick={() => removeStation(index)}
//             >
//               <AiFillCloseCircle color={"red"} size={20} />
//             </div>
//           )}
//         </div>
//       ))}

//       <SubmitButton
//         title={"Add Station"}
//         primary
//         onClick={addStation}
//         btnClass={styles.stationsBtn}
//         btnContainerClass={styles.stationBtnCont}
//       />
//     </div>
//   );
// };

// export default StationSetup;


import React, { useState } from "react";
import styles from "./StationSetup.module.css";
import {
  Dropdown,
  InputField,
  SubmitButton,
  TextComponent,
} from "../../../../../components";
import { Button, InputNumber } from "antd";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../../../Store/Actions/GeneralActions";
import { AiFillCloseCircle } from "react-icons/ai";
import { RxDragHandleDots2 } from "react-icons/rx";

import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

const SortableStationCard = ({
  station,
  index,
  updateStation,
  removeStation,
  stations,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: station.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} className={styles.stationCard}>
      <div className={styles.twoStationInput}>
        <div className={styles.stationContainers}>
          <Dropdown
            className={styles.stationsInput}
            label={"Station"}
            value={station.station}
            inputStyle={{ backgroundColor: "var(--white-color)" }}
            labelStyle={{ fontSize: 18 }}
            style={{ color: "black" }}
            options={[
              { value: "Mixing", id: 1 },
              { value: "Oven", id: 2 },
              { value: "Proof", id: 3 },
              { value: "Chill", id: 4 },
              { value: "Assembly", id: 5 },
              { value: "Packaging", id: 6 },
              { value: "Make Up", id: 7 },
            ]}
            onChange={(e) => updateStation(index, "station", e)}
          />
        </div>

        <div className={styles.stationContainers}>
          <Dropdown
            className={styles.stationsInput}
            label={"Recommended Skill"}
            value={station.skill}
            inputStyle={{ backgroundColor: "var(--white-color)" }}
            labelStyle={{ fontSize: 18 }}
            style={{ color: "black" }}
            options={[
              { value: "Apprentice", id: 1 },
              { value: "Intermediate", id: 2 },
               { value: "Expert", id: 3 },
            ]}
            onChange={(e) => updateStation(index, "skill", e)}
          />
        </div>
      </div>

      <div className={styles.twoStationInput2}>
        <div className={styles.stationContainers2}>
          <TextComponent
            text={"Recommended Number of Staff"}
            className={styles.stationCounterText}
          />
          <div className={styles.stationCounterCont}>
            <Button
              onClick={() =>
                updateStation(index, "staff", Math.max(0, station.staff - 1))
              }
            >
              -
            </Button>
            <InputNumber
              min={0}
              value={station.staff}
              onChange={(e) => updateStation(index, "staff", e)}
            />
            <Button
              onClick={() => updateStation(index, "staff", station.staff + 1)}
            >
              +
            </Button>
          </div>
        </div>

        <div className={styles.stationContainers2}>
          <Dropdown
            className={styles.stationsInput}
            label={"Select a Process"}
            value={station.process}
            inputStyle={{ backgroundColor: "var(--white-color)" }}
            labelStyle={{ fontSize: 18 }}
            style={{ color: "black" }}
            options={[
              { value: "MIX-SD-BASE", id: 1 },
              { value: "FILL-BOTTLE", id: 2 },
            ]}
            onChange={(e) => updateStation(index, "process", e)}
          />
        </div>
      </div>

      {/* Delete */}
      {stations.length > 1 && (
        <div
          className={styles.closeIcon}
          onClick={() => removeStation(index)}
          role="button"
          aria-label={`remove-station-${index}`}
        >
          <AiFillCloseCircle color={"red"} size={20} />
        </div>
      )}

      {stations.length > 1 && (
        <div
          className={styles.dragIconRight}
          {...attributes}
          {...listeners}
          role="button"
          aria-label={`drag-handle-${index}`}
        >
          <RxDragHandleDots2 size={20} />
        </div>
      )}
    </div>
  );
};

const StationSetup = () => {
  const dispatch = useDispatch();
  const [labourPerBatch, setLabourPerBatch] = useState("");
  const [recommendedSkill, setRecommendedSkill] = useState({
    value: "Apprentice",
    id: 1,
  });

  const [stations, setStations] = useState([
    { id: "1", station: "", skill: "", staff: 3, process: "" },
  ]);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: { distance: 5 },
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;
    const oldIndex = stations.findIndex((i) => i.id === active.id);
    const newIndex = stations.findIndex((i) => i.id === over.id);
    if (oldIndex === -1 || newIndex === -1) return;
    setStations((items) => arrayMove(items, oldIndex, newIndex));
  };

  const addStation = () => {
    const lastStation = stations[stations.length - 1];
    if (!lastStation.station || !lastStation.skill || !lastStation.process) {
      dispatch(
        showAlert({
          type: "error",
          message:
            "Please fill all fields in the current station before adding a new one.",
        })
      );
      return;
    }
    setStations([
      ...stations,
      { id: `${Date.now()}`, station: "", skill: "", staff: 3, process: "" },
    ]);
  };

  const removeStation = (index) => {
    setStations(stations.filter((_, i) => i !== index));
  };

  const updateStation = (index, key, value) => {
    const updated = [...stations];
    updated[index][key] = value;
    setStations(updated);
  };

  return (
    <div>
      {/* <div className={styles.TwoInputRow}>
        <InputField
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          className={styles.inputNew}
          label={"Estimated Labor Time per Batch"}
          placeholder={"15 minutes"}
          value={labourPerBatch}
          onChange={(e) => setLabourPerBatch(e.target.value)}
        />

        <Dropdown
          className={styles.inputNew}
          label={"Recommended Skill"}
          value={recommendedSkill}
          labelStyle={{ fontSize: 18 }}
          inputStyle={{ backgroundColor: "var(--white-color)" }}
          style={{ color: "black" }}
          options={[{ value: "Apprentice", id: 1 }]}
          onChange={(e) => setRecommendedSkill(e)}
        />
      </div> */}

      <TextComponent text={"Product Journey"} className={styles.productHeading} />

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragEnd={handleDragEnd}
        modifiers={[restrictToVerticalAxis]}
      >
        <SortableContext
          items={stations.map((s) => s.id)}
          strategy={verticalListSortingStrategy}
        >
          {stations.map((station, index) => (
            <SortableStationCard
              key={station.id}
              station={station}
              index={index}
              updateStation={updateStation}
              removeStation={removeStation}
              stations={stations}
            />
          ))}
        </SortableContext>
      </DndContext>

      <SubmitButton
        title={"Add Station"}
        primary
        onClick={addStation}
        btnClass={styles.stationsBtn}
        btnContainerClass={styles.stationBtnCont}
      />
    </div>
  );
};

export default StationSetup;
